import Cookies from "js-cookie";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const token = "user_token";
const roles = "role";
const userInfo = "userInfo";

export function getToken() {
  const value = Cookies.get(token);
  return value;
}

export function setToken(tokenVal) {
  return Cookies.set(token, tokenVal, { expires: 7 });
}

export function removeToken() {
  return Cookies.remove(token);
}

export function getRoles() {
  return Cookies.get(roles);
}

export function setRoles(rolesVal) {
  return Cookies.set(roles, rolesVal, { expires: 7 });
}

export function removeRoles() {
  return Cookies.remove(roles);
}

export function setUserInfo(infoVal) {
  Cookies.set(userInfo, JSON.stringify(infoVal), { expires: 7 });
}

export function getUserInfo() {
  const userInfo_cookie = Cookies.get(userInfo);
  const userInfo_obj = JSON.parse(userInfo_cookie);
  return userInfo_obj;
}

export function removeUserInfo() {
  return Cookies.remove(userInfo);
}

export function getDeviceId() {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    const fp = await FingerprintJS.load({ screen_resolution: true });
    const { visitorId } = await fp.get();
    resolve(visitorId);
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js